import { render, staticRenderFns } from "./lr.vue?vue&type=template&id=f6b0e522&"
import script from "./lr.vue?vue&type=script&lang=js&"
export * from "./lr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports